export default function Footer() {
  return (
    <footer className="bg-navy-950 text-navy-300">
      <div className="mx-auto max-w-6xl px-4 py-10 md:px-6">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-2.5">
            <span className="flex h-7 w-7 items-center justify-center rounded-md bg-lime-400 text-navy-950">
              <i className="ri-flashlight-line text-base" aria-hidden="true" />
            </span>
            <span className="font-heading text-sm font-bold text-white">短納期ホームページ制作</span>
          </div>

          <div className="flex items-center gap-4">
            <span className="rounded-full border border-navy-800 px-3 py-1 text-xs text-navy-300">
              サービス準備中
            </span>
            <a
              href="#top"
              className="flex items-center gap-1.5 whitespace-nowrap text-sm font-medium text-navy-300 transition-colors hover:text-lime-400"
            >
              ページの先頭へ
              <i className="ri-arrow-up-line" aria-hidden="true" />
            </a>
          </div>
        </div>

        <p className="mt-8 border-t border-navy-800 pt-6 text-xs text-navy-400">
          © {new Date().getFullYear()} 短納期ホームページ制作
        </p>
      </div>
    </footer>
  );
}